import React from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** When true, only company/admin users can access; professionals are redirected to appointments */
  requireCompanyAdmin?: boolean;
  /** When true, professionals can access this route. When false/undefined, professionals are redirected to /admin/appointments */
  allowedForProfessional?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireCompanyAdmin = false,
  allowedForProfessional = false,
}) => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const userData = authService.getUserData();
  const userType = userData?.userType;
  const isProfessional = userType === "professional";

  if (requireCompanyAdmin && isProfessional) {
    return <Navigate to="/admin/appointments" replace />;
  }

  if (isProfessional && !allowedForProfessional) {
    return <Navigate to="/admin/appointments" replace />;
  }

  return <>{children}</>;
};
